import ModalReserveMobile from "./ModalReserveMobile";
import ModalSelectDate from "components/ModalSelectDate";
import convertSelectedDateToString from "utils/convertSelectedDateToString";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { formatPrice } from "shared/AppFunctions/formatPrice";

export interface MobileFooterStickyProps {
  price: number | string;
  reviews?: number;
  rating?: string;
  startDate?: Date;
  isAvailable: boolean;
  showDateModal: boolean;
  endDate?: Date;
  onChangeDate?: (dates: [Date | null, Date | null]) => void;
  handleStartBooking: () => void;
  rangeAvailability?: any;
  label?: string;
  onSeePackages?: () => void;
}


const MobileFooterSticky = ({ price, reviews, startDate, endDate, onChangeDate, handleStartBooking, isAvailable, rangeAvailability, showDateModal, label, onSeePackages }: MobileFooterStickyProps) => {
  return (
    <div className="block lg:hidden fixed bottom-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 z-40">
      <div className="container flex items-center justify-between">
        <div className="flex flex-col">
          <span className="block text-xl font-semibold">
            {formatPrice(Number(price), true)}
            <span className="ml-1 text-sm font-normal text-neutral-500 dark:text-neutral-400">
              /notte
            </span>
          </span>
          {
            showDateModal && startDate && endDate && (
              <ModalSelectDate
                rangeAvailability={rangeAvailability}
                onChangeDate={(dates) => onChangeDate && onChangeDate(dates)}
                startDateParam={startDate}
                endDateParam={endDate}
                renderChildren={({ openModal }) => (
                  <span
                    onClick={openModal}
                    className="block text-sm underline font-medium"
                  >
                    {convertSelectedDateToString([startDate, endDate])}
                  </span>
                )}
              />
            )
          }
        </div>

        <ModalReserveMobile
          renderChildren={({ openModal }) => (
            <ButtonPrimary
              disabled={!isAvailable}
              sizeClass="px-5 sm:px-7 py-3 !rounded-2xl"
              onClick={() => (onSeePackages ? onSeePackages() : handleStartBooking())}
            >
              {label ?? "Prenota"}
            </ButtonPrimary>
          )}
        />
      </div>
    </div>
  );
};

export default MobileFooterSticky;
